import { createContext } from 'react';

export interface RadioCardGroupContextValue {
   value?: string;
   onChange?: (newValue: string) => void;
}

export const RadioCardGroupContext = createContext<RadioCardGroupContextValue>({});
